import { useCurrentWorkspaceMemberContext } from "~/providers/CurrentWorkspaceMemberProvider";
export const useCurrentWorkspaceMember = ()=>{
    return useCurrentWorkspaceMemberContext();
};
